import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useParams, Redirect } from 'react-router';
import { useQuery } from '@apollo/client';

import { ACTION_CODES } from 'constants/errors';
import AgentPortalError from 'errors/AgentPortalError';

import Button from 'components/ui/Button';
import { Spinner } from 'admin-components/components';
import { Page, Column } from 'components/shared/Layout';

export const GET_BOOKINGS_BY_REFERENCE = gql`
  query BookingsForReference($reference: String!) {
    bookings(reference: $reference) {
      reference
    }
  }
`;

const BookingReferenceSearchResults = ({ history }) => {
  const { reference } = useParams();

  const { loading, error, data } = useQuery(GET_BOOKINGS_BY_REFERENCE, {
    variables: { reference }
  });

  if (loading) {
    return (
      <Column alignItems="center" justifyContent="center">
        <Spinner />
      </Column>
    );
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: '/search/booking'
    });
  }

  if (data.bookings.length === 1) {
    return <Redirect to={`/manage/bookings/${data.bookings[0].reference}`} />;
  }

  if (data.bookings.length === 0) {
    return (
      <Page>
        <Column span={16}>
          <h1>
            <FormattedMessage id="bookingSearchResults.noResults" />
          </h1>
          <Button onClick={() => history.push('/search/booking')}>
            <FormattedMessage id="errorBoundary.goBack" />
          </Button>
        </Column>
      </Page>
    );
  }

  return (
    <Page>
      <Column span={16}>
        <h1>
          <FormattedMessage id="bookingSearchResults.summary.title" />
        </h1>

        <ul data-cy="bookings-for-reference">
          {data.bookings.map((result) => (
            <li key={result.reference}>
              <Link to={`/manage/bookings/${result.reference}`}>{result.reference}</Link>
            </li>
          ))}
        </ul>
      </Column>
    </Page>
  );
};

BookingReferenceSearchResults.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

export default BookingReferenceSearchResults;
